import { useTranslation } from 'react-i18next'

import { DocFlowMappingProcessCell } from '../../DocFlowMapping'
import { getSplittingValueInArea } from '../../DocFlowUploading'
import {
  getDocFlowSplittingAndMappingWidgetPermanentNotifications,
  getWidgetSplittingInitialValues,
  getWidgetSplittingNotifications,
  getWidgetSplittingProcessPayload,
  getWidgetSplittingSelectedAreaInfoData,
  getWidgetSplittingSelectedAreaPayload,
  isSplittingAreaValue,
} from '../../DocFlowWidgets'
import { useDocFlowMappingContext } from '../useDocFlowMappingContext'
import { useDocFlowMappingWidgetWithSelectedArea } from '../useDocFlowMappingWidgetWithSelectedArea'

export function useDocFlowMappingWidgetSplitting({ index, widgetName }) {
  const { t } = useTranslation()

  const { isPdfSelectAreaInfoValueLoading, isProcessDataLoading, processData } =
    useDocFlowMappingContext()

  const initialNotifications =
    getDocFlowSplittingAndMappingWidgetPermanentNotifications(t)

  const widgetNotifications = getWidgetSplittingNotifications(t)

  const {
    disabled,
    handleAddNotification,
    handleChangeAccuracy,
    handleClearFieldType,
    handleClickNext,
    handleClickPrevious,
    handleDebounceWidgetGetSelectedAreaInfo,
    handlePrependNotification,
    handleRemoveAdditionalNotifications,
    handleRemoveNotification,
    handleWidgetGetSelectedAreaInfo,
    hasError,
    nextButtonDisabled,
    notifications,
    unvisited,
    widgetDone,
  } = useDocFlowMappingWidgetWithSelectedArea({
    apiFunction: getSplittingValueInArea,
    areaType: DocFlowMappingProcessCell.SplittingArea,
    getSelectedAreaData: getWidgetSplittingSelectedAreaInfoData,
    getSelectedAreaPayload: getWidgetSplittingSelectedAreaPayload,
    getSubmitPayload: getWidgetSplittingProcessPayload,
    hasAreaCellName: DocFlowMappingProcessCell.HasSplittingArea,
    hasErrorCellName: DocFlowMappingProcessCell.HasPreSplittingError,
    index,
    initialNotifications,
    isAreaValue: isSplittingAreaValue,
    phaseType: DocFlowMappingProcessCell.SplittingPhase,
    widgetName,
    widgetNotifications,
  })

  const initialValues = getWidgetSplittingInitialValues(processData, t)

  return {
    disabled,
    handleAddNotification,
    handleChangeAccuracy,
    handleClearFieldType,
    handleClickNext,
    handleClickPrevious,
    handleDebounceWidgetGetSelectedAreaInfo,
    handleGetSplittingSelectedAreaInfo: handleWidgetGetSelectedAreaInfo,
    handlePrependNotification,
    handleRemoveAdditionalNotifications,
    handleRemoveNotification,
    hasError,
    initialValues,
    isLoading: isPdfSelectAreaInfoValueLoading || isProcessDataLoading,
    nextButtonDisabled,
    notifications,
    unvisited,
    widgetDone,
    widgetNotifications,
  }
}
